// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"4a99e58a","127":"5f81903d","297":"3849bdee"}[chunkId] + ".chunk.css";
};